import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { WooTableColumn } from '@src/shared/presentational/woo-table/woo-table-column/woo-table-column.component';
import { WooTableComponent } from '@src/shared/presentational/woo-table/woo-table.component';
import { DotLoader } from '../../src/shared/feedback/loader/dot-loader.component';
import { AgencyRoleSelect } from './components/agency-role-select.component';
import { EditUserCustomerAccess } from './components/edit-user-customer-access.component';
import { ManageAccounts } from './components/manage-accounts.component';
import { NameList } from './components/name_list/name-list.component';
import { NewUser } from './components/new-user.component';
import { UserForm } from './components/user-form.component';
import { UserList } from './components/user_list/user-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ManageAccounts,
    NameList,
    UserList,
    DotLoader,
    WooTableComponent,
    WooTableColumn,
    WooComponentsModule,
  ],

  providers: [],
  declarations: [AgencyRoleSelect, EditUserCustomerAccess, NewUser, UserForm],
  exports: [EditUserCustomerAccess, ManageAccounts, NewUser, UserForm],
})
export class WooUserAccountsModule {}
